export const AuthSortidaHorari = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Sortida del recinte en horaris diferents
        </h4>
        <p>
          Entenent que l’escola es troba dins d’un recinte públic i no disposa d’un espai tancat i vigilat, autoritzo
        </p>
        <p>
          <input type="checkbox" id="authSortidaHorari" name="authSortidaHorari" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authSortidaHorari">
            AUTORITZO el meu/va fill/a a sortir del centre (amb el consentiment del seu tutor o de la direcció del centre) quan no tinguin professor de guàrdia a última hora (13:30h-14:30h). També, quan no tingui classe a primera hora del matí, podrà entrar més tard al centre (08:00-9:00 h)
          </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>

      </div>
    </div>
  </>)
}
